import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentTypeRouterPaths } from '../shared/enums/content-type-router-paths';
import { ContentTypes } from '../shared/enums/content-types';
import { CitywireInternalAccountsGuard } from '@tpapa/citywire-internal-accounts-angular';
import { hasRole } from '../core/authorization/has-role';
import { USER_ROLES } from '../core/constants/cms-user-roles';
import { PagesContentModule } from '../pages-content/pages-content.module';
import { ArticleContentModule } from '../article-content/article-content.module';
import { SingleSponsorContentModule } from '../single-sponsor-content/single-sponsor-content.module';
import { ContentSetContentModule } from '../content-set-content/content-set-content.module';
import { GalleryContentModule } from '../gallery-content/gallery-content.module';
import { DigitalPublicationContentModule } from '../digital-publication-content/digital-publication-content.module';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [hasRole(USER_ROLES.CanWriteArticles)],
    children: [
      {
        path: '',
        redirectTo: ContentTypeRouterPaths[ContentTypes.PAGE],
        pathMatch: 'full',
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.PAGE],
        loadChildren: () => PagesContentModule,
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.ARTICLE],
        loadChildren: () => ArticleContentModule,
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.SINGLE_SPONSOR],
        loadChildren: () => SingleSponsorContentModule,
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.CONTENT_SET],
        loadChildren: () => ContentSetContentModule,
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.GALLERY],
        loadChildren: () => GalleryContentModule,
      },
      {
        path: ContentTypeRouterPaths[ContentTypes.DIGITAL_PUBLICATION],
        loadChildren: () => DigitalPublicationContentModule,
      },
    ],
    canActivate: [CitywireInternalAccountsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentRoutingModule {}
